import { Hero, TrustStrip } from "@/components/home/Hero";
import { InfrastructureSection, PortfolioSection, ZenPayFeature } from "@/components/home/Sections";
import { SecuritySection, SolutionsSection, ConnectedFinanceSection, CustomerTypesSection } from "@/components/home/Sections2";
import { EngineeringSection, SelectedWorkSection, WhyIjeevaSection, AboutSection } from "@/components/home/Sections3";
import { CTASection } from "@/components/common/Section";

export default function Home() {
  return (
    <>
      <Hero />
      <TrustStrip />
      <InfrastructureSection />
      <PortfolioSection />
      <ZenPayFeature />
      <SecuritySection />
      <SolutionsSection />
      <ConnectedFinanceSection />
      <CustomerTypesSection />
      <EngineeringSection />
      <SelectedWorkSection />
      <WhyIjeevaSection />
      <AboutSection />
      <CTASection />
    </>
  );
}
